export default "__VITE_ASSET__6p$cCFrp__"